import { render, staticRenderFns } from "./LinkedContact.vue?vue&type=template&id=42ccaf9e&scoped=true&"
import script from "./LinkedContact.vue?vue&type=script&lang=js&"
export * from "./LinkedContact.vue?vue&type=script&lang=js&"
import style0 from "./LinkedContact.vue?vue&type=style&index=0&id=42ccaf9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ccaf9e",
  null
  
)

export default component.exports